import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      setSettings(data);
    } catch (e) {
      setSettings(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <AppCtx.Provider value={{ settings, refreshSettings: load }}>{children}</AppCtx.Provider>;
}

export const useSettings = () => useContext(AppCtx);

export function waLink(settings, productName) {
  const biz = settings?.business || {};
  const number = biz.default_whatsapp || "919849966082";
  let msg = biz.whatsapp_message || "Hello, I am interested in AnVibes Exports products.";
  if (productName) msg = `Hello, I am interested in ${productName} from AnVibes Exports. I would like to discuss export/wholesale requirements.`;
  return `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;
}

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("anvibes_admin_token");
    if (!token) {
      setChecking(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("anvibes_admin_token"))
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("anvibes_admin_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("anvibes_admin_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, checking, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
